import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ClientBookingClassesResponseData } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const CLIENT_BOOKING_CLASSES_QUERY_KEY = 'client_booking_classes';

export const useClientBookingClassesQuery = (
  url: string,
  date: string | null,
) =>
  useQuery({
    queryKey: [CLIENT_BOOKING_CLASSES_QUERY_KEY, url, date],
    queryFn: () =>
      HttpClient.request<ClientBookingClassesResponseData>({
        method: 'GET',
        url,
        params: { date },
        headers: {
          Accept: 'application/json',
        },
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!date,
  });
